import { THEME } from './theme'
import type { TerrainVisualDefinition, TowerVisualDefinition } from './types'

export const TERRAIN_VISUALS: Record<TerrainVisualDefinition['id'], TerrainVisualDefinition> = {
  board: {
    id: 'board',
    fill: THEME.board,
    stroke: THEME.boardEdge,
    strokeAlpha: 0.9,
    kind: 'procedural'
  },
  grass: {
    id: 'grass',
    fill: THEME.grass,
    stroke: THEME.grid,
    strokeAlpha: 0.45,
    kind: 'procedural'
  },
  path: {
    id: 'path',
    fill: THEME.path,
    stroke: THEME.pathEdge,
    strokeAlpha: 0.55,
    kind: 'procedural'
  },
  spawn: {
    id: 'spawn',
    fill: THEME.spawn,
    stroke: THEME.white,
    strokeAlpha: 1,
    kind: 'procedural'
  },
  exit: {
    id: 'exit',
    fill: THEME.exit,
    stroke: THEME.selection,
    strokeAlpha: 1,
    kind: 'procedural'
  },
  grid: {
    id: 'grid',
    fill: THEME.grid,
    stroke: THEME.grid,
    strokeAlpha: 0.45,
    kind: 'procedural'
  }
}

export const TOWER_VISUALS: Record<string, TowerVisualDefinition> = {
  fire: {
    id: 'fire',
    definitionId: 'fire',
    letter: 'F',
    fill: THEME.fire,
    stroke: THEME.white,
    labelColor: '#ffffff',
    silhouette: 'triangle',
    kind: 'procedural'
  },
  frost: {
    id: 'frost',
    definitionId: 'frost',
    letter: 'I',
    fill: THEME.frost,
    stroke: THEME.white,
    labelColor: '#ffffff',
    silhouette: 'hexagon',
    kind: 'procedural'
  },
  cannon: {
    id: 'cannon',
    definitionId: 'cannon',
    letter: 'C',
    fill: THEME.cannon,
    stroke: THEME.white,
    labelColor: '#ffffff',
    silhouette: 'block',
    kind: 'procedural'
  },
  poison: {
    id: 'poison',
    definitionId: 'poison',
    letter: 'P',
    fill: THEME.poison,
    stroke: THEME.white,
    labelColor: '#14532d',
    silhouette: 'diamond',
    kind: 'procedural'
  },
  aa: {
    id: 'aa',
    definitionId: 'aa',
    letter: 'A',
    fill: THEME.aa,
    stroke: THEME.white,
    labelColor: '#0f172a',
    silhouette: 'antenna',
    kind: 'procedural'
  },
  mage: {
    id: 'mage',
    definitionId: 'mage',
    letter: 'M',
    fill: THEME.mage,
    stroke: THEME.white,
    labelColor: '#1e1b4b',
    silhouette: 'prism',
    kind: 'procedural'
  }
}

export const FALLBACK_TOWER_VISUAL: TowerVisualDefinition = {
  id: 'fallback-tower',
  definitionId: 'fallback',
  letter: '?',
  fill: THEME.white,
  stroke: THEME.danger,
  labelColor: '#0f172a',
  silhouette: 'fallback',
  kind: 'procedural'
}
